import { useEffect, useState } from 'react';
import Table from 'components/table';
import { ReportType, RootState } from 'types';
import './report-list.scss';
import { useSelector } from 'react-redux';
import { SECTION_REPORT_GENERATE, SECTION_REPORT_OPTIONS, SECTION_SCHEDULE, timeSince } from '../report-modal';

function ReportList({
    className,
    selectCallback,
    setSection,
    deleteSubmit
} : {
    className: string,
    selectCallback: (data:number) => void,
    setSection: (data: number) => void,
    deleteSubmit: (data:number) => void
}) {
        
    const state = useSelector((state: RootState) => state);
    const [page, setPage] = useState<number>(1);    
    const [reportsPage, setReportsPage] = useState<ReportType[]>([]);

    const getContactName = (id: number) => {
        var contact = state.clientContacts.find(x => x.Id === id);
        return contact ? (contact?.Name + ' ' + contact?.Surname) : 'amaSocial';
    } 

    useEffect(() => {
        setReportsPage(state.reports.slice(0, 10 * page))
    }, [state.reports, page])

    return (
        <div id={'report-list'} className={className ? className : 'table-container'}>
            <Table
                headers={{
                    Id: "ID",
                    ClientId: "",
                    ContactId: "CREATED BY",
                    Name: "REPORT NAME",
                    DateCreated: "CREATED",
                    LayoutId: "LAYOUT",
                    EditButton: "",
                    GenerateButton: "",
                    ScheduleButton: "",
                    DeleteButton: ""
                }}
                items={reportsPage.map(report => ({ 
                    Id: report.Id,
                    ClientId: report.ClientId,
                    ContactId: report.ContactId,
                    Name: report.Name,
                    DateCreated: report.DateCreated,
                    LayoutId: report.LayoutId,
                    EditButton: true,
                    GenerateButton: true,
                    ScheduleButton: true,
                    DeleteButton: true,
                }))}
                customRenderers={{
                    ClientId: (item) => (
                        null
                    ),
                    ContactId: (item) => (
                        getContactName(item.ContactId)
                    ),
                    DateCreated: (item) => (
                        // new Date(item.DateCreated).toLocaleString()
                        timeSince(new Date(item.DateCreated))
                    ),
                    LayoutId: (item) => (
                        state.reportOptions.LayoutOptions.find(x => x.Id === item.LayoutId)?.Description
                    ),
                    EditButton: (item) => (
                        <i  title="Edit" className='btn btn-edit far fa-pen' onClick={() => {
                            selectCallback(item.Id); 
                            setSection(SECTION_REPORT_OPTIONS);}} />
                    ),
                    GenerateButton: (item) => (
                        <i  title="Generate (New DR)" className='btn btn-generate far fa-plus' onClick={() => {
                            selectCallback(item.Id); 
                            setSection(SECTION_REPORT_GENERATE);}} />
                    ),
                    ScheduleButton: (item) => (
                        <i  title="Attach Schedule" className='btn btn-schedule far fa-calendar-plus' onClick={() => {
                            selectCallback(item.Id); 
                            setSection(SECTION_SCHEDULE);}} />
                    ),
                    DeleteButton: (item) => (
                        <i title="Delete" className='btn btn-delete far fa-trash-alt' onClick={() => { (window.confirm('Are you sure you wish to delete this item?')) && deleteSubmit(item.Id) }} />
                    ),
                }}
                />
                <div className='button-group'>
                    {reportsPage.length === state.reports.length ?  <p id="end-results"> ~~~ </p> : <button className='btn-load' onClick={() => setPage(page+1)}><i className='fas fa-chevron-circle-down fa-2x'></i></button>}
                    {page > 1 ?  <button className='btn-load' onClick={() => setPage(page-1)}><i className='fas fa-chevron-circle-up fa-2x'></i></button> : '' }
                </div>
        </div>
    )
}

export default ReportList;